<template>
  <div class="h-full w-full bg- flex flex-col">
    <div style="height: 56px" class="w-full relative">
      <!-- {{ fetchObj.time }} - {{ fetchObj.timer }} {{ grid }} -->
      <tool-bar
        @selected="
          (v) => {
            selectedUnits = v;
          }
        "
        :options="{
          search: false,
          filter: false,
          poi: true,
          export: false,
          traffic: true,
        }"
        @setTrafficLayer="setTrafficLayer"
        :initialSelect="props.selectedUnits"
        :isLegacy="isLegacy"
      >
        <template #right-start>
          <!-- <div>{{ gridSizeOptions[grid].label.split(' ')[0] }}</div> -->
          <vs-button
            size="small"
            class="px-3 flex flex-center"
            @click="refresh"
          >
            Refresh
          </vs-button>
          <vs-button
            size="small"
            class="px-3 flex flex-center"
            @click="centerAll"
          >
            Center All
          </vs-button>
          <button-group
            :btns="gridSizeOptions"
            @clicked="
              (btn) => {
                grid = btn.value;
              }
            "
          />
        </template>
      </tool-bar>
    </div>
    <div class="flex-1 flex flex-col bg-white relative" ref="content">
      <div
        v-for="(row, rowIndex) in gridOptions[grid][1]"
        :key="rowIndex"
        class="flex-1 flex bg-white"
        :style="{ height: `calc(100% / ${gridOptions[grid][1]})` }"
      >
        <div
          class="h-full flex bg-white relative flex-col"
          v-for="(col, colIndex) in gridOptions[grid][0]"
          :key="colIndex"
          style="padding: 0.5px"
          :style="{ width: `calc(100% / ${gridOptions[grid][0]})` }"
        >
          <div class="flex-1 flex flex-col bg-grey-light">
            <div class="flex-1 flex">
              <map-view
                v-if="views[getIndex(row, col)]"
                ref="map"
                class="flex-1"
                :key="getIndex(row, col)"
                :data="views[getIndex(row, col)]"
                :selectedUnit="views[getIndex(row, col)][0].assetId"
                :polyline="views[getIndex(row, col)][0].polylineArr"
                :circle="{
                  center: views[getIndex(row, col)][0].polylineArr
                    ? views[getIndex(row, col)][0].polylineArr.at(-1)
                    : undefined,
                  options: {
                    fillColor: `#16AE64`,
                    strokeColor: '#8A2BE2',
                    strokeOpacity: 0.8,
                    strokeWeight: 3,
                    fillOpacity: 1,
                  },
                }"
                :options="{ selectedUnitOutline: ' ' }"
                :initialZoom="12"
                :onMounted="mapOnMounted"
                :showTrafficLayer="showTrafficLayer"
              />
              <div v-else class="fit flex flex-col flex-center">
                <q-icon name="visibility_off" />
                Unused View
              </div>
            </div>
            <div
              class="w-full flex bg-grey-3"
              style="min-height: 30px"
              @click="getUnit"
            >
              <div
                v-if="views[getIndex(row, col)]"
                class="flex flex-1 items-center relative p-2"
              >
                <info-card
                  :data="views[getIndex(row, col)][0]"
                  class="flex flex-1 gap-1"
                  @center="getUnit(getIndex(row, col))"
                />
                <!-- {{ getIndex(row, col) }} -->
              </div>
              <!-- <div v-else class="p-1">Unused view</div> -->
            </div>
          </div>
        </div>
      </div>
      <div v-if="paginationPages > 1" class="w-full h-10 flex flex-center">
        <q-pagination
          v-model="current"
          :max="paginationPages"
          :max-pages="6"
          class="fix-button"
          direction-links
        />
      </div>

      <div
        v-if="isLoadingMain"
        class="absolute h-full w-full left-0 top-0 p-4 font-bold text-danger"
      >
        <q-inner-loading showing color="primary" />
      </div>
    </div>
  </div>
</template>

<script setup>
import ButtonGroup from '@/components/custom-ui/ButtonGroup.vue';
import { useElementSize, useScroll, useStyleTag } from '@vueuse/core';
import { axios } from '@/main.js';
import { computed, ref, onMounted, onUnmounted, watch } from 'vue';

import { customCss } from '../table-view/quasar.js';
import ToolBar from '../hybrid-view/ToolBar.vue';
import MapView from '../hybrid-view/MapView.vue';
import InfoCard from './InfoCard.vue';

const { id, css, load, unload } = useStyleTag(customCss, { id: 'naruto' });
onUnmounted(() => {
  unload();
});

const emit = defineEmits(['loaded', 'selected']);
const props = defineProps({
  data: {},
  isLegacy: { default: true },
  selectedUnits: {},
});

onMounted(() => {
  if (props.selectedUnits) {
    selectedUnits.value = props.selectedUnits;
  }
});

const fetchObj = ref({
  lap: 0,
  time: 0,
  seconds: 60,
  timer: null,
  cancel: false,
});

const data = ref([]);
const selectedUnits = ref([]);
const showTrafficLayer = ref(false);
const isLoadingMain = ref(false);
watch(
  () => fetchObj.value.lap,
  async () => {
    if (!fetchObj.value.timer) {
      fetchObj.value.cancel = false;
      startTimer();
    }
    isLoadingMain.value = true;
    current.value = 1;
    const promises = selectedUnits.value.map((e) => getData(e));
    data.value = await Promise.allSettled(promises);
    // console.log(data.value);
    isLoadingMain.value = false;
  },
);

watch(selectedUnits, () => {
  if (selectedUnits.value.length > 0) {
    fetchObj.value.lap++;
    grid.value = autoSelectGrid();
    emit('selected', selectedUnits.value);
  } else {
    if (fetchObj.value.timer) {
      fetchObj.value.cancel = true;
      resetTimer();
      data.value = [];
    }
    emit('selected', null);
  }
});

async function refresh() {
  fetchObj.value.lap++;
}
function autoSelectGrid() {
  let v = [];
  gridOptions.forEach((e, i) => {
    let total = e[0] * e[1];
    if (total >= selectedUnits.value.length) {
      if (v.length == 0) {
        v[0] = i;
      }
    } else {
    }
  });
  if (v.length == 0) {
    v[0] = gridOptions.length - 1;
  }
  return v[0];
}

const current = ref(1);
const paginationPages = computed(() => {
  return Math.ceil(data.value.length / perPageView.value);
});
const perPageView = computed(() => {
  return gridSizeOptions.value[grid.value].label.split(' ')[0];
});
function getItemsForPage(pageNumber, itemsPerPage, dataArray) {
  const startIndex = (pageNumber - 1) * itemsPerPage;
  const endIndex = Math.min(
    startIndex + itemsPerPage - 1,
    dataArray.length - 1,
  );

  return dataArray.slice(startIndex, endIndex + 1);
}

const views = computed(() => {
  let currentPage;
  // if (data.value.length > 15) {
  //   currentPage = getItemsForPage(current.value, perPageView.value, data.value);
  // } else {
  //   currentPage = data.value;
  // }

  currentPage = getItemsForPage(current.value, perPageView.value, data.value);
  let arr = currentPage.map((e) => {
    let assetData = e.value.mapMarkerData[0];
    assetData = [{ ...assetData, assetName: assetData.name }];
    return assetData;
  });
  return arr;
});

const userInfo = JSON.parse(localStorage.getItem('userInfo'));
const geoPOIData = JSON.parse(localStorage.getItem('geoPOIData'));
async function getData(id) {
  try {
    let response = await axios.post(`multiListener/${userInfo.uid}`, {
      selectedUnits: [id],
      geoPOIData: geoPOIData,
    });
    if (response.status == 200 && response.data.success) {
      return response.data;
    }
  } catch (error) {
    console.log(error);
    return;
  }
}
function startTimer() {
  fetchObj.value.time = fetchObj.value.seconds;
  fetchObj.value.timer = setInterval(() => {
    if (fetchObj.value.time > 0) {
      fetchObj.value.time--;
    } else {
      resetTimer();
    }
  }, 1000);
}
function resetTimer() {
  clearInterval(fetchObj.value.timer);
  if (!fetchObj.value.cancel) {
    fetchObj.value.timer = null;
    fetchObj.value.lap++;
  } else {
    fetchObj.value.timer = null;
  }
}

const grid = ref(0);
watch(grid, () => {
  current.value = 1;
});
const gridOptions = [
  [2, 2],
  [3, 2],
  [3, 3],
  [4, 3],
  [5, 3],
];
const gridSizeOptions = computed(() => {
  return gridOptions.map((e, i) => {
    let value = e[0] * e[1];
    let obj = {
      label: `${value} views`,
      value: i,
      class: i == grid.value ? 'bg-primary text-white' : '',
    };
    return obj;
  });
});

function getIndex(row, column) {
  // Adjust row and column indices to be 0-indexed
  const rowIndex = row - 1;
  const colIndex = column - 1;

  // Calculate the index
  const index = rowIndex * gridOptions[grid.value][0] + colIndex;
  return index;
}
function removeLineBreak(str) {
  return str.replace(/(\r\n|\n|\r)/gm, '');
}
function mapOnMounted(obj) {
  const { props, fitBounds } = obj;
  if (props.data.length == 1 && props.data[0].polylineArr) {
    fitBounds(props.data[0].polylineArr);
  }
}
function setTrafficLayer(v) {
  showTrafficLayer.value = v;
}
</script>
<script>
export default {
  methods: {
    getUnit(index) {
      // console.log(index, this.$refs.map);
      this.$refs.map[index]._setupState.getUnit();
    },
    centerAll() {
      this.$refs.map.forEach((e) => {
        e._setupState.getUnit();
      });
    },
  },
};
</script>
<style>
/* .gm-style-moc {
  opacity: 0 !important;
} */

.fix-button .row {
  margin: 0 !important;
  padding: 0;
}
</style>
